export const OPERATORS_MIXER = 'OPERATORS_MIXER';
export const PLANAR_SNAPSHOTS = 'PLANAR_SHAPSHOTS';
